<template lang="html">
    <div id="d-home-page">
        <section class="box-st-1 box-announcement">
        <div class="box-content">
                <router-link class="post-template-s1"
                  v-for="(b, bInx) in rows"
                  :key="'bInx-'+bInx" 
                  :to="{ name: 'accComuDetallePage', params: { id: b.id } }">
                  <div class="col placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+b.imageUrl+')' }" style="background-size: contain;"></div>
  
                  <div class="col box-text">
                    <h5 class="title">{{ b.title }}</h5>
                   
                    <div class="descr">
                      <p>{{ b.description }}</p>
                    </div>
  
                    <hr />
  
                    <p>
                      <span class="btn-more" style="color: #444749;
    cursor: pointer;
    display: inline-block;
    font-size: 1.1rem;
    font-weight: 600;
    height: 100%;
    text-align: center;
    width: 100%;">Ver detalle</span>
                    </p>
                  </div>
                </router-link>
            
        
        </div>
      </section>
  
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {

        rows:[],
      }
    },
  
    methods: {
      onSubmit(event) {
        event.preventDefault();
      },
      getRows(){
        axios.get(tools.url("/api/blogs")).then((response)=>{
            this.rows = response.data;
        }).catch(()=>{});
      }
    },
    mounted(){
        this.getRows();
    }
  }
  </script>
  